// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3XSSJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__3hltg"};